import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoEu: CultureInfo = {
  name: 'eu',
  displayName: 'Basque',
  iso3LanguageCode: 'eus',
  iso2LanguageCode: 'eu',
  ietfLanguageTag: 'eu',
  parent: null
};
